export default __webpack_public_path__ + "static/media/image10.20ae03b7.jpg";